import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getToken } from '../utils/token';
import { saveRedirectPath } from '../utils/redirectAfterLogin';

export default function RequireAuth({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasToken = !!getToken();

  useEffect(() => {
    if (!hasToken) {
      saveRedirectPath(location.pathname + location.search);
      navigate('/', { replace: true });
    }
  }, [hasToken, location.pathname, location.search, navigate]);

  if (!hasToken) {
    return null;
  }

  return children;
}
